import MessageCenter, { type MessageChannelConfig } from "@/pages/admin/messages/components/MessageCenter";

const config: MessageChannelConfig = {
  channel: "whatsapp",
  eyebrow: "Marketing",
  title: "WhatsApp",
  subtitle: "Trip plans, festival greetings and quick conversations over the channel guests reply to most.",
  icon: "ri-whatsapp-line",
  composeTitle: "Send WhatsApp",
  recipientLabel: "Phone number",
  recipientPlaceholder: "+91 98765 43210",
  subjectLabel: "Title",
  subjectPlaceholder: "e.g. Trip plan shared",
};

export default function AdminWhatsapp() {
  return <MessageCenter config={config} />;
}